<template>
  <div class="kw_select">
    <el-select v-model="myValue" :placeholder="placeholder" :clearable="clearable"
      @change="dropdownItemChange(item)" class="select_search" size="mini"
    >
      <template v-for="(dicItem,dicIndex) in showDicList">
        <el-option :key="dicIndex"
          v-if="(dicItem.ifShow==null||dicItem.ifShow==undefined)||dicItem.ifShow==true"
          :label="dicItem.DIC_NAME"
          :value="dicItem.DIC_ID+''">
        </el-option>
      </template>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'kw_select',
  props: {
    value:{

    },
    placeholder:{

    },
    clearable:{
      default:true
    },
    filterId:{
      default:""
    },
    item:{

    }
  },
  data() {
    return {
      myValue:this.value+'',
      showDicList :[]
    };
  },
  created() {
    console.log("item======================",this.item);
    this.changeFilterId(this.filterId);
  },
  mounted() {
    
  },
  watch:{
    value(newVal) {
      this.myValue = newVal+"";
    },
    myValue(newVal) {
      // console.log("myValue 切换=======================",newVal);
      this.$emit('input', newVal);
    },
    filterId(newVal){
      this.changeFilterId(newVal);
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    changeFilterId(newVal){
      console.log("newVal 切换=======================",newVal);
      var dicList = this.item.dicList;
      var showDicList = [];
      var filterId = newVal;
      if(filterId != null && filterId != undefined && filterId != '') {
        dicList.forEach(element => {
          if((element.FILTER_ID && (","+element.FILTER_ID+",").indexOf(","+filterId+",")>=0)||element.DIC_ID == 0) {
            element.ifShow = true;
            showDicList.push(element);
          } else {
            element.ifShow = false;
          }
        });
      } else {
        showDicList = dicList;
      }
      this.showDicList = showDicList;
    },
    dropdownItemChange(item){
      var that = this;
      this.$nextTick(function(){
          that.$emit("dropdownItemChange");
      });
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.select_search .el-input__inner{border:none;padding: 0;margin: 0 10px}
  .el_input_search .el-input__inner{background: transparent;border: none;border-radius: 30px;height: 34px;line-height: 34px}
  .el_input_search .el-input__icon{line-height: 34px}
</style>
